import { useEffect, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  extractMyStoreSlug,
  isAdminMode,
} from '../../../utility/util/util.service';
import { connect } from 'react-redux';
import {
  fetchOnStoreEntry,
  setStore,
} from '../../../redux/store/store.actions';
import { getStore } from '../../../utility/sb-api/sb-api.service';
import { fetchOrders } from '../../../redux/me/me.actions';
import {
  ROUTE_ERROR_404,
  ROUTE_ERROR_500,
  ROUTE_SIGNUP_STORE,
} from '../../../utility/constants';

const FetchData = ({
  fetchStore,
  redirectToSignUpStore,
  fetchUserOrders,

  me,
  store,
  orders,

  fetchOnStoreEntry,
  setStore,
  fetchOrders,

  children,
}) => {
  const history = useHistory();
  const { slug } = useParams();
  const isFetched = useRef(false);

  // fetch Store and all relevant data if fetchStore is set
  useEffect(() => {
    if (
      // only if fetchStore is true
      fetchStore &&
      // only if me has been resolved (anonymous => me = false)
      me !== null &&
      // fetch Store initially or on Store switch (slug changed)
      (store === null || (slug && store && store.slug !== slug)) &&
      // only if StoreOwner or slug is set
      (me?.isStoreOwner || slug) &&
      !isFetched.current
    ) {
      setStore(false);
      isFetched.current = true;
      const ownStoreSlug = extractMyStoreSlug(me);
      const isOwnStore = isAdminMode(me, slug);

      (slug
        ? // visiting e.g. /store/<slug> route
          getStore(slug, isOwnStore).then((store) => {
            fetchOnStoreEntry(store, isOwnStore);
            setStore(store);
          })
        : // visiting e.g. /dashboard route
          getStore(ownStoreSlug, true).then((store) => {
            fetchOnStoreEntry(store, true);
            setStore(store);
          })
      ).catch((err) => {
        console.error(err);

        if (err?.response) {
          // the client was given an error response (5xx, 4xx)
          if (err.response.status === 404) {
            history.push(ROUTE_ERROR_404);
          } else {
            history.push(ROUTE_ERROR_500);
          }
        } else {
          // anything else
          history.push(ROUTE_ERROR_500);
        }
      });
    } else if (me?.isStoreOwner === false && redirectToSignUpStore) {
      // if accessing store routes without having one
      history.push(ROUTE_SIGNUP_STORE);
    }
  }, [slug, fetchStore, me, store, history, fetchOnStoreEntry, setStore]);

  // fetch User Orders if fetchUserOrders is set
  useEffect(() => {
    if (fetchUserOrders && me && !orders) {
      fetchOrders({ limit: 15 });
    }
  }, [fetchOrders, fetchUserOrders, me, orders]);

  return children;
};

const mapStateToProps = (state) => ({
  me: state.me.me,
  orders: state.me.orders,
  store: state.store.store,
});

export default connect(mapStateToProps, {
  fetchOnStoreEntry,
  setStore,
  fetchOrders,
})(FetchData);
